import React, { useEffect, useMemo, useRef, useState } from 'react'

import Walls from './Walls';
import Storage from './Storage';
import Roof from './Roof';
import Truss from './Truss';
import InstallationSurface from './Installation_surface';
import { const_var , params} from '../../../redux/reducers/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { updateDoorWindowsArray } from '../../../action';
import * as actionCreator from '../../../action/index';
import DoorWindows from '../DoorWindows';
import Watermark from './Watermark'
import Cupolas from '../Cupolas';
import Measurements from '../Measurements';

const CenterBuilding = () => {
    const dispatch = useDispatch();
    const ref = useRef();

    const mainTrussPosInfo = useSelector(state => state.reducer.mainTrussPosInfo);
    const leanToTrussPosInfo = useSelector(state => state.reducer.leanToTrussPosInfo);

    const [overlapTrussArr, setOverlapTrussArr] = useState([]);
    const [newDoorsArray, setNewDoorsArray] = useState(const_var.newDoorsArray)

    const prv_p_w = useMemo(() => {
        const prv_p_w = ref.current
        ref.current = params.p_w;
        
        return prv_p_w    
    }, [params.p_w])
    
    useEffect(() => {
        if (const_var.newDoorsArray.length > 0) {
            const legThickness = 0.24;
            const updatedDoorsArr = const_var.newDoorsArray.map((item, index)=> {
                let cutLegCount = 0;
                if (item.userData.wallName === 'c_b_r_w' || item.userData.wallName === 'c_b_l_s_r_w' || item.userData.wallName === 'c_b_r_s_w' || item.userData.wallName === 'L_L_R_S_W' ||
                    item.userData.wallName === 'c_b_l_w' || item.userData.wallName === 'c_b_r_s_l_w' || item.userData.wallName === 'c_b_l_s_w' || item.userData.wallName === 'R_L_L_S_W'
                ) {
                    if (mainTrussPosInfo?.length > 0) {
                        mainTrussPosInfo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    } 
                } else if (item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W') {
                    if (leanToTrussPosInfo?.frontLeanTo?.length > 0) {
                        leanToTrussPosInfo.frontLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                } else if (item.userData.wallName === 'B_L_S_W' || item.userData.wallName === 'B_L_F_S_W') {
                    if (leanToTrussPosInfo?.backLeanTo?.length > 0) {                        
                        leanToTrussPosInfo.backLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                } else if (item.userData.wallName === 'R_L_R_W' ||  item.userData.wallName === 'R_L_R_S_W') {
                    if (leanToTrussPosInfo?.rightLeanTo?.length > 0) {                        
                        leanToTrussPosInfo.rightLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                } else if (item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W') {
                    if (leanToTrussPosInfo?.leftLeanTo?.length > 0) {                        
                        leanToTrussPosInfo.leftLeanTo.map(e => {
                            if (e >= item.positionX - (item.width + legThickness) / 2 && e <= item.positionX + (item.width + legThickness) / 2) cutLegCount += 1;
                        })
                    }
                }
                return {
                    ...item,
                    cutLegCount,
                }
            })

            if (JSON.stringify(updatedDoorsArr) !== JSON.stringify(const_var.newDoorsArray)) {
                setNewDoorsArray(updatedDoorsArr)
            }
        }
    }, [const_var.newDoorsArray, mainTrussPosInfo, leanToTrussPosInfo])
    
    useEffect(() => {
        dispatch(updateDoorWindowsArray(newDoorsArray));
    }, [newDoorsArray])    

    useMemo(() => {
        if(params.cB_addStorage_check_left){
            const_var.newDoorsArray.filter((e) => e.userData.wallName === "c_b_l_s_f_w" || e.userData.wallName === "c_b_l_s_b_w").map((item) => {
                let newPositionX;
                if(item.userData.wallName === 'c_b_l_s_f_w'){
                    newPositionX = item.positionX + (prv_p_w - params.p_w) / 2;
                }else {
                    newPositionX = item.positionX - (prv_p_w - params.p_w) / 2;
                }
               
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
            });
        } else if(params.cB_addStorage_check_right){
            const_var.newDoorsArray.filter((e) => e.userData.wallName === "c_b_r_s_f_w" || e.userData.wallName === "c_b_r_s_b_w").map((item) => {
                let newPositionX;
                if(item.userData.wallName === 'c_b_r_s_f_w'){
                    newPositionX = item.positionX - (prv_p_w - params.p_w) / 2;
                }else {
                    newPositionX = item.positionX + (prv_p_w - params.p_w) / 2;
                }
               
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
            }); 
        }

    }, [params.p_w, prv_p_w, params.cB_addStorage_check_left, params.cB_addStorage_check_right])

    return (
        <>
            <Walls />
            <Storage />
            <Roof />
            <InstallationSurface />
            <Watermark/>
            <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} />
            {(const_var.DistanceArr!=undefined && const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) && 
                <Truss overlapTrussArr={overlapTrussArr} />
            }
            <group name='Measurements-main'>
                <Measurements />
            </group>
            {const_var.cupolas.length > 0 && <Cupolas />}
        </>
    )
}

export default CenterBuilding